import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Style layering, in order:
//   1. design-system v3 — Token UND Bauteilklassen (--brand, --text, --space-*,
//      .card, .btn, .input, .page …). v3/base.css zieht compat/v2-aliases.css
//      selbst mit, die v2-Namen loesen also weiter auf.
//
// Die beiden ui-react-Stylesheets sind ersatzlos entfallen: 3.x liefert GAR KEIN
// CSS mehr aus (weder styles.css noch dist/index.css existieren im Paket). Die
// Bauteile stylen inline und ueber die Klassen des Design-Systems. Waeren die
// Zeilen stehengeblieben, haette der Bau sie als fehlende Module gemeldet.
import '@weretradeit/design-system/v3/base.css';
import './index.css';
// 4.2.1: die Szene dieser App fuer GlyphLoader, GlyphErrorPage und die
// ErrorBoundary steht BEWUSST NICHT hier (Flottenregel seit 09.10.2026). Ein
// statischer Import an dieser Stelle liess die Engine zeichnen, bevor die
// Huelle stand, und sie konnte der App den Hauptthread nehmen (accountingFox
// PR 790, CI-E2E rot). Sie laedt jetzt App.tsx beim Einhaengen, im
// Leerlauf — Begruendung in glyphScene.ts.

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
